import { GraphQLResponseWithData } from 'relay-runtime';

import { GROUP_STATUS_DONE } from '../const';
import { MiddlewareType } from './types';
import { getSettingsResponse } from './util';

type AnyObject = Record<string, unknown>;

const deepMerge = <T extends AnyObject, U extends AnyObject>(target: T, source: U): T & U => {
    const result: AnyObject = { ...target };

    for (const key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
            const sourceValue = source[key];
            const targetValue = result[key];
            if (isObject(targetValue) && isObject(sourceValue)) {
                result[key] = deepMerge(targetValue, sourceValue);
            } else {
                result[key] = sourceValue;
            }
        }
    }
    return result as T & U;
};

const isObject = (value: unknown): value is AnyObject => {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
};

export const settingsMiddleware: MiddlewareType = async (args, next) => {
    const { operation, variables } = args;

    if (operation.operationKind === 'mutation' && operation.name === 'UpdateSettingMutation') {
        const existingSettings = JSON.parse(localStorage.getItem('settings') ?? '{}');
        const existingData = JSON.parse(existingSettings.data ?? '{}');
        const newData = deepMerge(existingData, JSON.parse(variables.input.data ?? '{}'));
        const newSettings = deepMerge(existingSettings, variables.input);
        newSettings.data = JSON.stringify(newData);
        localStorage.setItem('settings', JSON.stringify(newSettings));
        return getSettingsResponse(operation.operationKind, newSettings);
    }

    if (operation.operationKind === 'query' && operation.name === 'SettingsQuery') {
        const existingSettings = localStorage.getItem('settings');

        if (!existingSettings) {
            const settingsResponse = (await next(args)) as GraphQLResponseWithData;

            const settingsFromServer = settingsResponse.data?.settings?.edges?.[0]?.node;
            if (!settingsFromServer) {
                const defaultSettings = { data: JSON.stringify({ statusTaskDone: GROUP_STATUS_DONE }) };
                localStorage.setItem('settings', JSON.stringify(defaultSettings));
                return getSettingsResponse(operation.operationKind, defaultSettings);
            }

            localStorage.setItem('settings', JSON.stringify(settingsFromServer));
            return settingsResponse;
        }

        return getSettingsResponse(operation.operationKind, JSON.parse(existingSettings));
    }

    return next(args);
};
